import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

const Policy = () => {
  const { slug } = useParams();
  const [policy, setPolicy] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); api.get(`/policies/${slug}`).then((r) => setPolicy(r.data)).catch(() => setPolicy("error")); }, [slug]);
  if (policy === "error") return <div className="py-24 text-center font-serif text-2xl">Page not found</div>;
  if (!policy) return <div className="py-24 text-center">Loading...</div>;
  return (
    <div className="mx-auto max-w-3xl px-6 py-16" data-testid="policy-page">
      <nav className="mb-4 text-xs text-muted-text"><Link to="/" className="hover:text-burgundy">Home</Link> / <span className="text-charcoal">{policy.title}</span></nav>
      <h1 className="font-serif text-4xl text-burgundy">{policy.title}</h1>
      <span className="mt-3 block h-0.5 w-16 bg-burgundy" />
      <div className="mt-8 whitespace-pre-line leading-relaxed text-charcoal">{policy.content}</div>
    </div>
  );
};

export default Policy;
